import request from '#api/axios';
import { useMutation } from '@tanstack/react-query';

export default function useOnboardingCompleteMutation() {
  return useMutation({
    mutationFn: async () => {
      await request({
        url: '/accounts/onboarding',
        method: 'PATCH'
      });
    }
  });
}
